import styled from 'styled-components';

export const Group = styled.div`
  display: inline-flex;
  align-items: stretch;
  border: 1px solid rgba(184, 150, 74, 0.55);
  border-radius: 999px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.12);
`;

export const Segment = styled.button<{ $active: boolean }>`
  appearance: none;
  border: none;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  padding: 0.42rem 0.85rem;
  line-height: 1;
  transition: background-color 0.25s ease, color 0.25s ease;
  background: ${({ $active, theme }) => ($active ? theme.colors.accent : 'transparent')};
  color: ${({ $active, theme }) => ($active ? theme.colors.dark : theme.colors.accent)};

  &:hover {
    background: ${({ $active, theme }) => ($active ? theme.colors.accent : 'rgba(184, 150, 74, 0.18)')};
  }

  & + & {
    border-left: 1px solid rgba(184, 150, 74, 0.4);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0.38rem 0.7rem;
    font-size: 0.74rem;
  }
`;
